import { useEffect } from 'react';
import { useMap } from '@vis.gl/react-google-maps';
export const Polygon = ({ path, options }) => {
    const map = useMap();
    useEffect(() => {
        if (!map)
            return undefined;
        const polygon = new google.maps.Polygon(Object.assign(Object.assign({}, options), { paths: path }));
        polygon.setMap(map);
        return () => {
            polygon.setMap(null);
        };
    }, [map, path, options]);
    return null;
};
